import { useNavigate } from "react-router-dom"
import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

import useCustomerEditModal from "hooks/useCustomerEditModal"
import { useUserProfile } from "hooks/useUserProfile"

const Container = styled.div<{ isClickable: boolean }>`
  text-decoration: ${({ isClickable }) => (isClickable ? "underline" : "none")};
  color: ${({ isClickable }) => (isClickable ? "#2db2c8" : "#0f172a")};
  cursor: ${({ isClickable }) => (isClickable ? "pointer" : "default")};

  &:hover {
    opacity: ${({ isClickable }) => (isClickable ? "0.8" : "1")};
  }
`

interface DevicesCountProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const DevicesCount = ({ cell }: DevicesCountProps) => {
  const navigate = useNavigate()
  const { onShowEditCustomerModal, renderEditCustomerModal } = useCustomerEditModal()
  const { isContractor, isContractorTechnician } = useUserProfile()
  const devicesCount = cell.getValue().value as number | undefined
  const rowItem = cell.row.original.rowSettings.item
  const rowSettings = cell.row.original.rowSettings

  const customerId: number | null = rowItem.client_id || rowSettings.id || null

  const isClickable = !!(devicesCount !== undefined && devicesCount > 0 && customerId)

  const handleClick = () => {
    if (!customerId || !isClickable) return

    if (isContractorTechnician) {
      onShowEditCustomerModal(customerId)
      return
    }

    if (isContractor) {
      const email = rowSettings.item?.email

      if (email) {
        const params = new URLSearchParams({ email })
        navigate(`/devices?${params.toString()}`)
      }
      return
    }

    navigate(`/customers/${customerId}/overview`)
  }

  const displayValue = devicesCount !== undefined ? devicesCount : "-"

  return (
    <>
      <Container isClickable={isClickable} onClickCapture={isClickable ? handleClick : undefined}>
        {displayValue}
      </Container>
      {renderEditCustomerModal()}
    </>
  )
}
